// extracted by mini-css-extract-plugin
module.exports = {"error_container":"SearchError_error_container__2idDm","error_details":"SearchError_error_details__3bDkS"};